import React from "react";
import DollarCat from "../images/dollar-cat.png";
import PhoneCat from "../images/cat-with-phone.png";
import GiftCat from "../images/gift-cat.png";
import FeatureContent from "./feature-content/FeatureContent";
import { firstFeatureContent, secondFeatureContent, thirdFeatureContent } from "../utils/features";

function FeatureSection() {
 
  return (
    <section className="mx-auto ">
      <div className="flex items-center mb-20 wrapper wrapper-feat flex-col md:flex md:flex-row">
        <div className="w-full md:w-1/2">
          <FeatureContent feature={firstFeatureContent} />
        </div>
        <div className="w-full md:w-1/2">
          <img src={DollarCat} alt="Reporting" />
        </div>
      </div>

      <div className="flex items-center flex-wrap mb-20 wrapper wrapper-feat">
        <div className="w-full md:w-1/2">
          <img src={PhoneCat} alt="phone-cat" className="phone-cat-img" style={{ marginLeft: "3%" }} />
        </div>
        <div className="w-full md:w-1/2 md:pl-10">
          <FeatureContent feature={secondFeatureContent} />
        </div>
      </div>

      <div className="flex items-center mb-20 wrapper wrapper-feat flex-col md:flex md:flex-row">
        <div className="w-full md:w-1/2">
          <FeatureContent feature={thirdFeatureContent} />
        </div>
        <div className="w-full md:w-1/2 flex justify-center">
          <img src={GiftCat} alt="gift-cat" className="gift-cat-img"/>
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
